import React, { Component } from 'react';
import './ErrorCard.scss';
import {
    PropTypes
} from 'prop-types';
import {
    EmvioCard
} from '@nexio/emvio-util-ui';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getGoBackTarget } from '../Routes/routesEntity';
import { goBack } from '../Routes/routesActions';
import {
    goBackTargetShape,
    historyShape
} from '../../utils/propTypes';

export class ErrorCard extends Component {
    static propTypes = {
        goBackTarget: goBackTargetShape,
        history: historyShape,
        onGoBack: PropTypes.func,
        errorMessage: PropTypes.string,
        errorLinkMessage: PropTypes.string
    };

    render() {
        return (
            <EmvioCard>
                <div className="error-card">
                    <span className="icon-face" />
                    <div className="error-message">
                        <div>{this.props.errorMessage ? this.props.errorMessage : 'Something went wrong...'}</div>
                    </div>
                    <p className="error-link" onClick={this.props.onGoBack(this.props.history, this.props.goBackTarget)}>
                        {this.props.errorLinkMessage ? this.props.errorLinkMessage : 'Click here to go back or refresh your browser'}
                    </p>
                </div>
            </EmvioCard>
        );
    }
}

function mapStateToProps(state) {
    return {
        goBackTarget: getGoBackTarget(state)
    };
}

function mapDispatchToProps() {
    return {
        onGoBack: (history, goBackTarget) => () => goBack(history, goBackTarget)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorCard));
